// components
import CalendarContainer from '../components/CalendarContainer/CalendarContainer';
import AppointmentFormVisibility from '../components/AppointmentForm/AppointmentFormVisibility';
import Header from '../components/Header/Header';

// providers
import DialogProvider from 'components/shared/DialogProvider/DialogProvider';

// styles
import {
  CalendarSection,
  Content,
  MultiResourceContainer
} from './MultiResourcePlanning.styles';

// store
import ShortcutProvider from 'components/shared/ShortcutProvider';
import { CalendarInteractionProvider } from '../components/CalendarContainer/components/CalendarInteractionProvider/CalendarInteractionProvider';
import ContextPanel from '../components/ContextPanel/ContextPanel';
import { useRefetchPlanningOnEntityChange } from './MultiResourcePlanning.hook';

const MultiResourcePlanning = () => {
  const { hasAddAppointmentAccess, appointment } =
    useRefetchPlanningOnEntityChange();

  return (
    <ShortcutProvider>
      <DialogProvider>
        <CalendarInteractionProvider>
          <MultiResourceContainer>
            <CalendarSection fullWidth={!appointment}>
              <Header />

              <Content>
                <CalendarContainer />
                <ContextPanel isAppointmentOpen={!!appointment} />
              </Content>
            </CalendarSection>

            {hasAddAppointmentAccess && <AppointmentFormVisibility />}
          </MultiResourceContainer>
        </CalendarInteractionProvider>
      </DialogProvider>
    </ShortcutProvider>
  );
};

export default MultiResourcePlanning;
